import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { GetVodafonePKRequest, GetVodafoneTemlikHesaplasmaResponse } from '../models/model'

export class GetHesaplasmaApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'VodafoneReports/GetVodafoneHesaplasmaList',
      requesterInfo,
    })
  }

  public async getList(request: GetVodafonePKRequest): Promise<GetVodafoneTemlikHesaplasmaResponse[]> {
    return await this.postAsync<GetVodafoneTemlikHesaplasmaResponse[]>(request)
  }
}